import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { urlToPattern } from "../urlToPattern";
import logo from "./logo.svg";

export const workRamp = defineConnector({
  identifier: "workRamp",
  name: "WorkRamp",
  tagLine: "Learning and enablement platform",
  logo,
  protocol: "http",
  tags: ["productivity"],
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Get your WorkRamp integration key",
      items: [
        {
          kind: "markdown",
          content:
            "In WorkRamp, create an integration API key from the integration settings and use it as a bearer token for API requests.",
        },
      ],
    },
    {
      title: "Enter your WorkRamp details",
      items: [
        {
          kind: "url",
          label: "WorkRamp base URL",
          required: true,
          placeholder: "https://app.workramp.com",
          target: { kind: "configuration", field: "instanceUrl" },
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ instanceUrl }) =>
      `${instanceUrl || "https://app.workramp.com"}/api/v1/users`,
  },
  defaultUrlPattern: ({ instanceUrl }) =>
    urlToPattern(instanceUrl, "https://.*\\.workramp\\.com/.*"),
});
